import { render, staticRenderFns } from "./ChatLoader.vue?vue&type=template&id=5ff7ebf9&scoped=true&"
import script from "./ChatLoader.vue?vue&type=script&lang=js&"
export * from "./ChatLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChatLoader.vue?vue&type=style&index=0&id=5ff7ebf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7ebf9",
  null
  
)

export default component.exports